import MarketingHeader from '@/components/marketing/MarketingHeader';
import MarketingFooter from '@/components/marketing/MarketingFooter';

export const LegalPage = ({ title, lastUpdated, children, testId }) => {
  return (
    <div className="min-h-screen bg-[#070d1c] text-slate-100" data-testid={testId}>
      <MarketingHeader />

      <section className="relative pt-32 pb-12 bg-gradient-to-br from-[#0c1530] to-[#070d1c]">
        <div className="absolute inset-0 pointer-events-none opacity-40">
          <div className="absolute top-0 right-1/4 h-[300px] w-[300px] rounded-full bg-amber-400/10 blur-3xl" />
          <div className="absolute top-10 left-1/4 h-[300px] w-[300px] rounded-full bg-sky-500/10 blur-3xl" />
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-amber-300/40 to-transparent" />
        <div className="relative max-w-3xl mx-auto px-6 lg:px-8">
          <p className="text-amber-300 text-sm font-medium uppercase tracking-widest">Legal</p>
          <h1 className="font-manrope font-bold text-4xl sm:text-5xl tracking-tight text-white mt-3 leading-tight">
            {title}
          </h1>
          <p className="mt-4 text-slate-400 text-sm">
            Last updated {lastUpdated}.
          </p>
        </div>
      </section>

      <section className="py-12 bg-[#070d1c]">
        <div className="max-w-3xl mx-auto px-6 lg:px-8 legal-content">
          {children}
        </div>
      </section>

      <MarketingFooter />
    </div>
  );
};

export default LegalPage;
